import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import usePrevious from '../../hooks/usePrevious';

const ScrollingCalendar = () => {
	const container = useRef(null);
	const containerNav = useRef(null);
	const containerOffset = useRef(null);
	const currentTimeLine = useRef({});

	const [currentTimemarker, setCurrentTimemarker] = useState();

	useEffect(() => {
		// Set the container scroll position based on the current time.
		const currentMinute = new Date().getHours() * 60;
		if (currentTimeLine?.current) {
			currentTimeLine?.current[currentTimemarker?.hours - 4]?.scrollIntoView({
				behavior: 'smooth',
			});
		}
	}, [currentTimeLine, currentTimemarker]);

	const checkTime = () => {
		const currentTime = moment().get('hours');
		const currentMinutes = moment().get('minutes');
		let mins =
			currentMinutes < 15
				? 0
				: currentMinutes < 30
				? 1
				: currentMinutes < 45
				? 2
				: currentMinutes < 59
				? 3
				: 0;

		return { hours: currentTime * 4 + 1, minutes: mins };
	};

	const pew = usePrevious(currentTimemarker);

	useEffect(() => {
		const timer = setInterval(() => {
			if (JSON.stringify(pew) !== JSON.stringify(checkTime())) {
				setCurrentTimemarker(checkTime());
			}
		}, 5000);

		return () => clearInterval(timer);
	}, [pew]);

	return (
		<div ref={container} className="flex flex-auto flex-col overflow-auto">
			<div
				ref={containerNav}
				className="sticky top-0 z-10 grid flex-none grid-cols-7 bg-gray-700 text-xs text-gray-500 shadow ring-1 ring-black ring-opacity-5 md:hidden"
			>
				<button
					type="button"
					className="flex flex-col items-center pb-1.5 pt-3"
				>
					<span>W</span>
					{/* Default: "text-gray-900", Selected: "bg-gray-900 text-white", Today (Not Selected): "text-indigo-600", Today (Selected): "bg-indigo-600 text-white" */}
					<span className="mt-3 flex h-8 w-8 items-center justify-center rounded-full text-base font-semibold text-gray-900">
						19
					</span>
				</button>
				<button
					type="button"
					className="flex flex-col items-center pb-1.5 pt-3"
				>
					<span>T</span>
					<span className="mt-3 flex h-8 w-8 items-center justify-center rounded-full text-base font-semibold text-indigo-600">
						20
					</span>
				</button>
				<button
					type="button"
					className="flex flex-col items-center pb-1.5 pt-3"
				>
					<span>F</span>
					<span className="mt-3 flex h-8 w-8 items-center justify-center rounded-full text-base font-semibold text-gray-900">
						21
					</span>
				</button>
				<button
					type="button"
					className="flex flex-col items-center pb-1.5 pt-3"
				>
					<span>S</span>
					<span className="mt-3 flex h-8 w-8 items-center justify-center rounded-full bg-gray-900 text-base font-semibold text-white">
						22
					</span>
				</button>
				<button
					type="button"
					className="flex flex-col items-center pb-1.5 pt-3"
				>
					<span>S</span>
					<span className="mt-3 flex h-8 w-8 items-center justify-center rounded-full text-base font-semibold text-gray-900">
						23
					</span>
				</button>
				<button
					type="button"
					className="flex flex-col items-center pb-1.5 pt-3"
				>
					<span>M</span>
					<span className="mt-3 flex h-8 w-8 items-center justify-center rounded-full text-base font-semibold text-gray-900">
						24
					</span>
				</button>
				<button
					type="button"
					className="flex flex-col items-center pb-1.5 pt-3"
				>
					<span>T</span>
					<span className="mt-3 flex h-8 w-8 items-center justify-center rounded-full text-base font-semibold text-gray-900">
						25
					</span>
				</button>
			</div>
			<div className="flex w-full flex-auto">
				<div className="w-14 flex-none bg-gray-800 ring-1 ring-gray-700" />
				<div className="grid flex-auto grid-cols-1 grid-rows-1">
					{/* Horizontal lines */}
					<div
						className="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-700"
						style={{
							gridTemplateRows: 'repeat(48, minmax(2.5rem, 1fr))',
						}}
					>
						<div ref={containerOffset} className="row-end-1 h-7"></div>
						<div ref={(ref) => (currentTimeLine.current['1'] = ref)}>
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								12AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['5'] = ref)}>
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								1AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['9'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								2AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['13'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								3AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['17'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								4AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['21'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								5AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['25'] = ref)}>
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								6AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['29'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								7AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['33'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								8AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['37'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								9AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['41'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								10AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['45'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								11AM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['49'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								12PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['53'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								1PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['57'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								2PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['61'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								3PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['65'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								4PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['69'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								5PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['73'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								6PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['77'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								7PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['81'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								8PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['85'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								9PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['89'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								10PM
							</div>
						</div>
						<div />
						<div ref={(ref) => (currentTimeLine.current['93'] = ref)}>
							{' '}
							<div className="sticky left-0 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
								11PM
							</div>
						</div>
						<div />
					</div>

					{/* Events */}
					<ol
						className="col-start-1 col-end-2 row-start-1 grid grid-cols-1 mt-10"
						style={{
							gridTemplateRows: '0rem repeat(96, minmax(0, 1fr)) auto',
						}}
					>
						<li
							id="currentTimeLine"
							ref={currentTimeLine}
							className="relative mt-px flex items-center"
							style={{
								gridRow: `${
									currentTimemarker?.hours + currentTimemarker?.minutes
								} / span 1`,
							}}
						>
							<div className="w-3 h-3 bg-blue-500 rounded-2xl" />
							<div className="border-t border-blue-500 flex-1" />
						</li>
						{/*}     
<li
    className="relative mt-px flex"
    style={{ gridRow: '134 / span 18' }}
>
    <a
        href="#"
        className="group absolute inset-1 flex flex-col overflow-y-auto rounded-lg bg-indigo-50 p-2 text-xs leading-5 hover:bg-indigo-100"
    >
        <p className="order-1 font-semibold text-indigo-700">
            LRP Visit
        </p>
        <p className="order-1 text-indigo-500 group-hover:text-indigo-700">
            Liconic STX220 (S/N 1223)
        </p>
        <p className="text-indigo-500 group-hover:text-indigo-700">
            <time dateTime="2022-01-22T11:00">11:00 AM</time>
        </p>
    </a>
</li>*/}
					</ol>
				</div>
			</div>
		</div>
	);
};

export default ScrollingCalendar;
